import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainNavbar from "./components/navbar";
import SiteModeProvider from "./components/SiteModeProvider";
import { RETAIL_ROUTES, LEGACY_REDIRECTS } from "./lib/siteMode";
import DualEducation from "./pages/DualEducation";
import NemzetiBajnokok from "./pages/NemzetiBajnokok";
import ElmaradottTersegBruhazas from "./pages/ElmaradottTersegBruhazas";
import BusinessLoanConsulting from "./pages/BusinessLoanConsulting";
import CorporateAccountOptimize from "./pages/CorporateAccountOptimize";
import Footer from "./components/footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Container from "react-bootstrap/Container";
import Impresszum from "./pages/Impresszum";
import Rolunk from "./pages/Rolunk";
import ThanksPage from "./pages/ThanksPage";
import FrameworkContract from "./pages/FrameworkContract";
import VallalatiHome from "./pages/VallalatiHome";
import LakossagiHome from "./pages/LakossagiHome";
import Jelzaloghitel from "./pages/Jelzaloghitel";
import SzemelyiKolcson from "./pages/SzemelyiKolcson";
import LakossagiBankszamla from "./pages/LakossagiBankszamla";
import Nyugdijmegtakaritas from "./pages/Nyugdijmegtakaritas";
import Eletbiztositas from "./pages/Eletbiztositas";

export default function App() {
  return (
    <BrowserRouter>
      <SiteModeProvider>
        <MainNavbar />
        <Routes>
          {/* Retail (lakossági) — default page at "/" */}
          <Route path="/" element={<LakossagiHome />} />
          <Route path="/lakossagi" element={<LakossagiHome />} />

          {/* Corporate (vállalati) */}
          <Route path="/vallalati" element={<VallalatiHome />} />
          <Route path="/nemzeti-bajnokok" element={<NemzetiBajnokok />} />
          <Route path="/dualis-kepzes" element={<DualEducation />} />
          <Route
            path="/elmaradott-tersegek-tamogatasa"
            element={<ElmaradottTersegBruhazas />}
          />
          <Route path="/vallalati-hitel" element={<BusinessLoanConsulting />} />
          <Route
            path="/szamlaoptimalizalas"
            element={<CorporateAccountOptimize />}
          />
          <Route path="/penzugyi-orangyal" element={<FrameworkContract />} />

          {/* Retail (lakossági) — nested products */}
          <Route
            path={RETAIL_ROUTES.jelzaloghitel}
            element={<Jelzaloghitel />}
          />
          <Route
            path={RETAIL_ROUTES.szemelyiKolcson}
            element={<SzemelyiKolcson />}
          />
          <Route
            path={RETAIL_ROUTES.bankszamla}
            element={<LakossagiBankszamla />}
          />
          <Route
            path={RETAIL_ROUTES.nyugdijmegtakaritas}
            element={<Nyugdijmegtakaritas />}
          />
          <Route
            path={RETAIL_ROUTES.eletbiztositas}
            element={<Eletbiztositas />}
          />

          {/* Legacy flat retail paths → nested equivalents */}
          {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
            <Route
              key={from}
              path={from}
              element={<Navigate to={to} replace />}
            />
          ))}

          {/* Shared */}
          <Route path="/adatkezelesi-tajekoztato" element={<PrivacyPolicy />} />
          <Route path="/impresszum" element={<Impresszum />} />
          <Route path="/rolunk" element={<Rolunk />} />
          <Route path="/koszonjuk" element={<ThanksPage />} />
        </Routes>
        <Container className="py-0">
          <Footer />
        </Container>
      </SiteModeProvider>
    </BrowserRouter>
  );
}
